import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseGuard } from './base.guard';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class ListOperationGuard extends BaseGuard {

  constructor() {
    super();
  }

  protected override _checkCanActivate() {
    if (this._userController.isDemoUser
      || this._userController.isRapidViewsUser
    ) { return true; }

    this._redirectToBaseRoute();

    return false;
  }
}
